import dva from 'dva';
import createLoading from 'dva-loading';

const runtimeDva = window.g_plugins.mergeConfig('dva');
let app = dva({
  history: window.g_history,
  
  ...(runtimeDva.config || {}),
});

window.g_app = app;
app.use(createLoading());
(runtimeDva.plugins || []).forEach(plugin => {
  app.use(plugin);
});

app.model({ namespace: 'global', ...(require('/home/quan/logivan/shippers/src/models/global.js').default) });
app.model({ namespace: 'login', ...(require('/home/quan/logivan/shippers/src/models/login.js').default) });
app.model({ namespace: 'menu', ...(require('/home/quan/logivan/shippers/src/models/menu.js').default) });
app.model({ namespace: 'order', ...(require('/home/quan/logivan/shippers/src/models/order.js').default) });
app.model({ namespace: 'profile', ...(require('/home/quan/logivan/shippers/src/models/profile.js').default) });
app.model({ namespace: 'setting', ...(require('/home/quan/logivan/shippers/src/models/setting.js').default) });
